import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export const LoadingBackdrop = (props: { isOpen: boolean }) => {
    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={props.isOpen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}